





























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'

import EditCarac from  '@/components/groupCarac/edit/EditCarac.vue'
import CheckState from '@/components/shared/CheckState.vue'
import { AloGroupCarac, getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac'

@Component({
  name: 'ReadMarques',    
  components:{CheckState,EditCarac},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    groupCarac:{
      type:Object,
      default:getDefaultAloGroupCarac()
    },
    editable:{
      type:Boolean,
      default:true      
    }
  }
})
export default class ReadMarques extends Vue {
  
  private groupCarac!:AloGroupCarac
  private loading!:boolean

  edit() {     
    (this.$refs.editCaracteristiques as EditCarac).edit(this.groupCarac)
  }  


  get caracteristiques(){    
    return this.groupCarac.grcParamJson.caracIdxcs.map(id => this.$store.myGetters.carac[id]).filter(c => !!c)
  }
}
